import React from "react";

export default function NadoAll(color) {
    return (<svg
        width="20px"
        height="20px"
        viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.69216 13.0926L5.34755 14.3924L1 10L5.34755 5.60767L6.69216 6.95227L4.54079 9.05882H19.69V10.9413H4.54079L6.69216 13.0926Z"
        />
    </svg>);
}